// SPDX-License-Identifier: AGPL-3.0-or-later
/**
 * A small RFC 4180 CSV parser: quoted fields, doubled quotes, commas and
 * newlines inside quotes, CRLF or LF line endings, and a leading byte-order
 * mark. Blank lines are skipped.
 */
export function parseCsv(text) {
    const input = text.charCodeAt(0) === 0xfeff ? text.slice(1) : text;
    const rows = [];
    let row = [];
    let field = "";
    let quoted = false;
    for (let i = 0; i < input.length; i++) {
        const ch = input[i];
        if (quoted) {
            if (ch === '"') {
                if (input[i + 1] === '"') {
                    field += '"';
                    i++;
                }
                else {
                    quoted = false;
                }
            }
            else {
                field += ch;
            }
            continue;
        }
        if (ch === '"' && field === "") {
            quoted = true;
        }
        else if (ch === ",") {
            row.push(field);
            field = "";
        }
        else if (ch === "\n" || ch === "\r") {
            if (ch === "\r" && input[i + 1] === "\n")
                i++;
            row.push(field);
            if (row.some((f) => f.trim() !== ""))
                rows.push(row);
            row = [];
            field = "";
        }
        else {
            field += ch;
        }
    }
    row.push(field);
    if (row.some((f) => f.trim() !== ""))
        rows.push(row);
    return rows;
}
//# sourceMappingURL=csv.js.map